module.exports = "/assets/img/ipallets/line_title.png";